// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2609":"2421e722a70200f6","4278":"69ee0a236db424bf"}[chunkId] + ".css";
};